import { render, staticRenderFns } from "./OverflowMenu.vue?vue&type=template&id=3a345ca8&scoped=true&"
import script from "./OverflowMenu.vue?vue&type=script&lang=js&"
export * from "./OverflowMenu.vue?vue&type=script&lang=js&"
import style0 from "./OverflowMenu.vue?vue&type=style&index=0&id=3a345ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a345ca8",
  null
  
)

export default component.exports